// extracted by mini-css-extract-plugin
export default {"questionContainer":"styles_questionContainer__DNyBR","questionIcon":"styles_questionIcon__Lp6K7","questionText":"styles_questionText__xLXRF"};